import React, { Fragment } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Hero2 from '../components/Hero2/Hero2';
import SocialProof from '../components/SocialProof/SocialProof';
import Content from '../components/Content/Content';
import Benefits from '../components/Benefits/Benefits';
import OptionsTabs from '../components/OptionsTabs/OptionsTabs';
import CTA from '../components/CTA/CTA';
import Gallery from '../components/Gallery/Gallery';
import Process from '../components/Process/Process';
import FAQs from '../components/FAQs/FAQs';
import SEO from '../components/SEO/SEO';

type RentaCajasSecasProps = {}

const RentaCajasSecas:React.FC<RentaCajasSecasProps> = (props: RentaCajasSecasProps) => {
  return (
    <Fragment>
      <SEO
        title="Grupo GM | Renta de cajas secas en Hidalgo"
        description="En Grupo GM nos especializamos en la renta de cajas secas para el transporte de mercancías en Hidalgo. Ofrecemos soluciones logísticas flexibles y adaptadas a las necesidades de tu empresa."
        canonicalUrl="https://grupo-gm.mx/renta-cajas-secas-hidalgo"
      />
      <Navbar fixedScrolled={true} contactRibbon={true} />
      <Hero2 />
      <SocialProof />
      <Benefits
        title="¿Por qué rentar tu caja seca con nosotros en Hidalgo?"
        description="Aquí hay algunas razones por las cuales nuestros clientes nos dan su confianza para la renta de cajas secas"
        slots={[
          {
            title: 'Entrega inmediata',
            content: 'Contamos con una flota activa de más de 50 cajas secas y plataformas disponibles para entrega inmediata, listas para integrarse a tu operación sin generar tiempos muertos.'
          },
          {
            title: 'Cajas secas en perfecto estado',
            content: 'Todos nuestros equipos reciben mantenimiento constante y revisiones periódicas para garantizar un funcionamiento seguro, eficiente y confiable durante toda tu operación.'
          },
          {
            title: 'Mantenimiento incluido',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que las cajas secas estén en condiciones óptimas.'
          },
          {
            title: 'Ubicación estratégica en Hidalgo',
            content: 'Nuestra ubicación en Hidalgo nos permite atender con rapidez a empresas y transportistas en todo el centro del país, reduciendo costos y tiempos de traslado del equipo.'
          },
          {
            title: 'Atención rápida y personalizada',
            content: 'Brindamos atención directa vía llamada o WhatsApp, con respuesta inmediata y asesoría personalizada para ayudarte a elegir el equipo más adecuado según tu tipo de carga.'
          },
        ]}
      />
      <OptionsTabs
        tabs={[
          {
            id: 'cajas-secas-53',
            label: 'Cajas secas de 53 ft.',
            title: 'Cajas secas de 53 ft.',
            description: <div className='leading-7'>
            <div><strong>1. Dimensiones típicas</strong>
              <ul className="sublist">
                <li>Longitud interior: 52.5 ft (16.0 m)</li>
                <li>Ancho interior: 100–101 in (2.54 m)</li>
                <li>Altura interior: 110–114 in (2.80–2.90 m)</li>
              </ul>
            </div>
            <div className='mt-3'><strong>2. Capacidad</strong>
              <ul className="sublist">
                <li>Volumen: 3,000–3,850 cu ft</li>
                <li>Capacidad de carga: 42,000–45,000 lb (19,000–20,400 kg)</li>
                <li>Palets: ≈ 26 palets (48"×40") en configuración típica (hasta ~30 con configuraciones densas)</li>
              </ul>
            </div>
          </div>,
            image: 'https://grupogm-assets.s3.us-east-1.amazonaws.com/tipos-cajas-secas/cajaseca1ai.webp'
          },
          {
            id: 'cajas-secas-48',
            label: 'Cajas secas de 48 ft.',
            title: 'Cajas secas de 48 ft.',
            description: <div className='leading-7'>
              <div><strong>1. Dimensiones típicas</strong>
                <ul className="sublist">
                  <li>Longitud interior: 47.5 ft (14.5 m)</li>
                  <li>Ancho interior: 100–101 in (2.54 m)</li>
                  <li>Altura interior: 110–114 in (2.80–2.90 m)</li>
                </ul>
              </div>
              <div className='mt-3'><strong>2. Capacidad</strong>
                <ul className="sublist">
                  <li>Volumen: 2,800–3,500 cu ft</li>
                  <li>Capacidad de carga: 42,000–45,000 lb</li>
                  <li>Palets: ≈ 24 palets (48"×40")</li>
                </ul>
              </div>
            </div>,
            image: 'https://grupogm-assets.s3.us-east-1.amazonaws.com/tipos-cajas-secas/cajaseca3ai.webp'

          },
          {
            id: 'cajas-secas-40',
            label: 'Cajas secas de 40 ft.',
            title: 'Cajas secas de 40 ft.',
            description: <div className='leading-7'>
              <div><strong>1. Dimensiones típicas (contenedor)</strong>
                <ul className="sublist">
                  <li>Longitud interior: 39.5 ft (12.0 m)</li>
                  <li>Ancho interior: 92–94 in (2.35 m)</li>
                  <li>Altura interior (estándar): 86–90 in</li>
                </ul>
              </div>
              <div className='mt-3'><strong>2. Capacidad</strong>
                <ul className="sublist">
                  <li>Volumen: Estándar 2,350–2,400 cu ft; High Cube 2,650–2,700 cu ft</li>
                  <li>Capacidad de carga: 55,000–59,000 lb (varía según chasis y normativa)</li>
                  <li>Palets: ≈ 20 palets (48"×40")</li>
                </ul>
              </div>
            </div>,
            image: 'https://grupogm-assets.s3.us-east-1.amazonaws.com/tipos-cajas-secas/cajaseca5ai.webp'
          }
        ]}
      />
      <CTA 
        title="Servicio profesional de renta de cajas secas en Hidalgo" 
        description="Grupo GM ofrece renta de cajas secas en Hidalgo, con equipos en excelente estado y atención profesional. Brindamos soluciones confiables y rápidas para transporte y logística. Si buscas servicio seguro y eficiente, Grupo GM es tu mejor opción."
        buttonText="Cotizar ahora"
      />
      <Process
        title="Proceso de renta de cajas secas"
        description="Nuestro proceso de renta de cajas secas es rápido, claro y sin complicaciones. Te acompañamos paso a paso, desde la confirmación de disponibilidad hasta la entrega del equipo en Hidalgo, garantizando un servicio eficiente y confiable para tu operación."
        steps={[
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"></path>
              </svg>
            ),
            title: 'Confirma disponibilidad de caja seca',
            description: 'Verificamos en tiempo real el equipo disponible según tus necesidades de capacidad y ubicación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 3v4a1 1 0 0 1-1 1H5m4 6 2 2 4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"></path>
              </svg>
            ),
            title: 'Envía tus datos y documentos',
            description: 'Compártenos la información necesaria para agilizar el proceso de renta y validación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 11.917 9.724 16.5 19 7.5"></path>
              </svg>
            ),
            title: 'Recibe y acepta tu cotización',
            description: 'Te enviamos una propuesta clara, sin costos ocultos, lista para aprobación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"></path>
              </svg>
            ),
            title: 'Programa la entrega en Hidalgo',
            description: 'Coordinamos fecha y lugar para que recibas tu caja seca de forma puntual.'
          }
        ]}
      />
      <Gallery
        title="Equipos disponibles"
        description="Explora nuestra galería de cajas secas disponibles y conoce el estado, capacidades y características de cada equipo. Todas nuestras unidades se encuentran listas para trabajar y cumplir con tus necesidades de transporte y logística."
        buttonText="Verificar disponibilidad"
        images={[
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja14.webp",
            alt: "Caja seca disponible 1"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja45.webp",
            alt: "Caja seca disponible 2"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja31.webp",
            alt: "Caja seca disponible 3"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja33.webp",
            alt: "Caja seca disponible 4"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja48.webp",
            alt: "Caja seca disponible 5"
          }
        ]}
      />
      <Content
        title='Renta de cajas secas en todo Hidalgo'
        description='Operamos en todo el estado de Hidalgo y zonas clave del centro del país, ofreciendo disponibilidad constante de equipos y atención rápida donde tu operación lo necesite.'
      />
      <FAQs
        slots={[
          {
            title: '¿Cuánto cuesta rentar una caja seca en Hidalgo?',
            content: 'Contamos con una flota activa de más de 50 cajas secas disponibles para entrega inmediata, listas para integrarse a tu operación sin generar tiempos muertos.'
          },
          {
            title: '¿Puedo rentar por una semana?',
            content: 'Todos nuestros equipos reciben mantenimiento constante y revisiones periódicas para garantizar un funcionamiento seguro, eficiente y confiable durante toda tu operación.'
          },
          {
            title: '¿Entregan en mi municipio?',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que las cajas secas estén en condiciones óptimas.'
          },
          {
            title: '¿Qué capacidad tienen?',
            content: 'Nuestra ubicación en Hidalgo nos permite atender con rapidez a empresas y transportistas en todo el centro del país, reduciendo costos y tiempos de traslado del equipo.'
          },
          {
            title: '¿Qué necesito para contratar?',
            content: 'Brindamos atención directa vía llamada o WhatsApp, con respuesta inmediata y asesoría personalizada para ayudarte a elegir el equipo más adecuado según tu tipo de carga.'
          },
        ]}
      />
      <Footer />
    </Fragment>
  )
}

export default RentaCajasSecas;